// extracted by mini-css-extract-plugin
module.exports = {"resetBtn":"sKBRtQFUGjM_kRkHpLaRV","icon":"_3AwBA5qaC_4tUCIeDia-7b","active":"_1XKbRD7IqGSSZR3G050ceD"};